import { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Countdown, type CountdownProps } from '@/components/Countdown';

import { ScTimerLabel, type ScTimerLabelProps } from './styled';

const SECONDS_IN_DAY = 86_400;

const getTime = (time: number) => (time < 0 ? 0 : time);

export const TimerLabel: FC<
  Pick<CountdownProps, 'timeLeft'> & ScTimerLabelProps
> = ({ timeLeft, ...props }) => {
  const { t } = useTranslation();

  const isDaysShown = useMemo(() => timeLeft > SECONDS_IN_DAY, [timeLeft]);

  return (
    <ScTimerLabel {...props}>
      <Countdown dual timeLeft={getTime(timeLeft)}>
        {({ days, hours, minutes, seconds }) => (
          <>
            {isDaysShown && (
              <>
                <div>
                  {days}
                  {t('timer.dd')[0]}
                </div>
                <div>:</div>
              </>
            )}

            <div>
              {hours}
              {t('timer.hh')[0]}
            </div>
            <div>:</div>
            <div>
              {minutes}
              {t('timer.mm')[0]}
            </div>

            {!isDaysShown && (
              <>
                <div>:</div>
                <div>
                  {seconds}
                  {t('timer.ss')[0]}
                </div>
              </>
            )}
          </>
        )}
      </Countdown>
    </ScTimerLabel>
  );
};
